/* tslint:disable */
import { RoleResource } from "./RoleResource"
import { Role2Resource } from "./Role2Resource"

export class UserResource {
		active: boolean;
		address: string;
		answer: number;
		birthDate: string;
		communityManager: boolean;
		dateCreated: string;
		dateUpdated: string;
		departmentString: string;
		email: string;
		email2: string;
		enabled: boolean;
		errorCode: number;
		errorMessage: string;
		expertise: string;
		firstName: string;
		gender: string;
		image: string;
		imageString: string;
		jobTitle: string;
		lastName: string;
		password: string;
		phone: string;
		position: string;
		prefix: string;
		rid: number;
		sessionId: string;
		role: RoleResource;
		role2: Role2Resource;
		canUseAppointments:boolean;
		
		constructor() {
			this.rid = -1
		}
}
